import { formatInviteCode, type MiniLeague } from '@h2h/shared';
import { shareWithFeedback } from '../../lib/share';

/** Public deep link that prefills the join code for the recipient. */
export function miniLeagueInviteUrl(code: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}/leagues/join?code=${encodeURIComponent(code)}`;
}

export async function shareMiniLeagueInvite(mini: Pick<MiniLeague, 'name' | 'inviteCode'>) {
  const pretty = formatInviteCode(mini.inviteCode);
  await shareWithFeedback(
    {
      title: mini.name,
      text: `Join my HeadToHead mini league "${mini.name}" — use code ${pretty} or tap the link.`,
      url: miniLeagueInviteUrl(mini.inviteCode)
    },
    'Invite link copied'
  );
}

export type MiniLeagueNavState = {
  from?: 'friends' | 'play';
  leagueId?: string;
};

/** Where the hub back button should land based on entry context. */
export function hubBackPath(state: MiniLeagueNavState | null | undefined): string {
  if (state?.from === 'play' && state.leagueId) return `/play/${state.leagueId}`;
  if (state?.from === 'friends' && state.leagueId) return `/play/${state.leagueId}/friends`;
  return '/friends';
}

export function hubBackLabel(state: MiniLeagueNavState | null | undefined): string {
  if (state?.from === 'play') return 'Compete';
  return 'Friends';
}

export function createMiniLeaguePath(leagueId?: string | null): string {
  return leagueId ? `/leagues/new?leagueId=${encodeURIComponent(leagueId)}` : '/leagues/new';
}
